var React = require('react');
var Radium = require('radium');

var Well = require('react-bootstrap/lib/Well');
var Order = require('./Order');
var OrderDetail = require('./OrderDetail');
var TotalOrders = require('./TotalOrders');
var Toggle = require('../../Toggle/Toggle');

var w = window;
var d = w.document;

var style = {
	container: {
		marginTop: 50,
		width: '100%',
		height: '100%'
	},

	orderBox: {
		zIndex: 2,
    	overflowY: 'hidden',
    	position: 'relative',
    	width: 360,
    	height: '100%'
	},

	mapWrapper: {
		marginLeft: 360,
		width: '100%',
		height: '100%'
	}
}

require('./MyOrders.css');

var MyOrdersBox = Radium(React.createClass({

	getInitialState: function() {
		return {
			active: null,
			onlyOpen: false
		};
	},

	componentWillMount: function() {
		this.props.subscribe(this.props.auth.id);
		this.props.unloadSpecific();
	},

	componentWillUnmount: function() {
		this.props.unsubscribe();
	},

	componentDidMount: function() {
    	var me = this, google = w.google;

    	w.GMap = new google.maps.Map(d.getElementById('map'), {
			center: {lat: -23.5652911, lng: -46.6498139},
			zoom: 15,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});
	},

	openOrderDetail: function(key) {
		var me = this, details = d.querySelector('.order-details.activebox');

		if (details) {
			me.props.unloadSpecific();
			
			d.querySelector('.order-details').classList.remove('activebox');
			d.querySelector('.order-details').classList.add('nextbox');
			d.querySelector('.orders-brief').classList.remove('backbox');
			d.querySelector('.orders-brief').classList.add('activebox');

		} else {
			me.props.loadSpecific(key);
			
			d.querySelector('.orders-brief').classList.remove('activebox');
			d.querySelector('.orders-brief').classList.add('backbox');
			d.querySelector('.order-details').classList.remove('nextbox');
			d.querySelector('.order-details').classList.add('activebox');
		}
	},

	totalValue: function(myorders) {
		if(this.state.onlyOpen) {
			myorders = myorders.filter( function( elem, i, array ) {
				return elem.status < 3;
			} );
		}
		
		var value = 0;
		for (var index in myorders) {
			value += myorders[index].value;
		}
		return value;
	},

	onlyOpenAction: function() {
		this.setState({ onlyOpen: !this.state.onlyOpen});
	},

	render: function() {
		var me = this;
		var myOrders = me.props.myorders;

		if(me.state.onlyOpen) {
			myOrders = myOrders.filter( function( elem, i, array ) {
				return elem.status < 3;
			} );
		}
		
		let orders = myOrders.map((order) => {
			return (
				<Order
					key={order.key}
					id={order.key}
					order={order.order}
					status={order.status}
					createdAt={order.createdAt}
					onClick={me.openOrderDetail}
				/>
			)
		});

		return (
			<div style={style.container}>
				<div className="myOrdersBox">
					<Well className="orders-brief activebox">
					<Toggle label="Mostrar apenas em aberto"
						showTitle={true} 
						checked={me.state.onlyOpen} 
						onChange={me.onlyOpenAction} />
						{orders}
						<TotalOrders
							value={me.totalValue(me.props.myorders)}
						/>
					</Well>

					<Well className="order-details nextbox">
						<OrderDetail 
							order={me.props.specificOrder}
							onClick={me.openOrderDetail}
							loading={me.props.loadingOrder}
						/>
					</Well>
				</div>

				<div style={style.mapWrapper}>
					<div id="map"/>
				</div>	
			</div>
		);
	}

}));

module.exports = MyOrdersBox;


// WEBPACK FOOTER //
// ./src/components/Client/MyOrders/MyOrders.jsx